import { EncryptResponse } from '@com-delta-idp/mnx-trip-management-shared-ui';

export const ENCRYPTED: EncryptResponse = {
  recordLocator: 'mn964zzno5GGaipcJNw1GksUJdrkYA2/E9DoHnuiXBU=',
  chaufferToken: 'mn964zzno5GGaipcJNw1GksUJdrkYA2',
  passengers: [
    {
      firstName: 'AznS6LCu0/pOamvIK1DcSIm6XV+JLcu0yut30rNlcPY=',
      lastName: 'ozU8gXCWHIZeeFNletp5hZ6/kARV7blHrBTvclW8d7U=',
      firstNameNum: 'rk9MPE1qK6wuQZGizM/Xkq9imUSHodtqaXtKkF91ZC0=',
      LastNameNum: 'rk9MPE1qK6wuQZGizM/Xkq9imUSHodtqaXtKkF91ZC0=',
      passengerResourceId: '2d8z22z4-b59d-3ca6-zeb0-cc9z40586zz9',
      tickets: [
        {
          number: 'f0VN78NpPW6qqDkRofviouictjZpYiC4dWpTCXNhAwE'
        }
      ]
    }
  ],
  trips: [
    {
      tripId: '1',
      segments: [
        {
          segmentId: '1',
          marketingCarrier: 'DL',
          flightNum: 'BM9hSVqEzrr+veHICS+DsOg7Kw6r1igVbzn8KGCoJfE='
        },
        {
          segmentId: '2',
          marketingCarrier: 'DL',
          flightNum: 'n1ftTTyuBMVIHA/eAs64Nl3ckxkLFfcJ6p9ac1QEzWo='
        },
        {
          segmentId: '3',
          marketingCarrier: 'DL',
          flightNum: 'T7l572t+cu+4ADioKg0dAjX2KnlJ5dvlCgX5f74d0Bo='
        }
      ]
    },
    {
      tripId: '2',
      segments: [
        {
          segmentId: '4',
          marketingCarrier: 'DL',
          flightNum: 'H7as/MbN13XgI83QxGjIEDTsHnB/TmOnE9qsh8ZcT7c='
        },
        {
          segmentId: '5',
          marketingCarrier: 'DL',
          flightNum: 'DNKSiJDhdDPSL6fVeObHRl1iVHDcjIEV1u9Q7t6kLTA='
        },
        {
          segmentId: '6',
          marketingCarrier: 'DL',
          flightNum: 'CIG9WF6vuePF2ZGbJKd5j5USf3qxfHwn+7PrghH0/Y0='
        }
      ]
    }
  ]
};
